/**
 * TimelineListBase is a base class for items that need to be placed on the timeline
 * e.g. Event instances & feeling data points
 */
class TimelineListBase {
	constructor () {
		this._items = [];
		this._ids = [];
		this._startTimes = []; // array of start times.
		this._endTimes = []; // array of end times.
		this._index = -1;
		this._firstInView = 0; // index of first event in view,
		this._lastInView = 0; // index of last event in view
	}
	get items () {
		return this._items;
	}
	get item () {
		return this._index === -1 ? false : this._items[this._index];
	}
    get index () {
        return this._index;
    }
	get count () {
        return this._ids.length;
    }
	get isEmpty () {
		return this.count == 0;
	}
	add (item, id, startTime, endTime){
		if (typeof endTime == 'undefined') endTime = startTime;
		this.moveToTime(startTime);

		if (this._index < 0) this._index = 0;
		this._items.splice(this._index, 0, item);
		this._ids.splice(this._index, 0, id);
		this._startTimes.splice(this._index, 0, startTime);
		this._endTimes.splice(this._index, 0, endTime);
		// if (this._index <= this._firstInView) this._firstInView++;
		// if (this._index <= this._lastInView) this._lastInView++;
	}
	idExists (id) {
		return this._ids.indexOf(id) !== -1;
	}
    moveToPosition (position) {
        if (position < 0 || this._ids.length <= position) return false;
        this._index = position;
        return true;
    }
    moveToId (id) {
        this._index = this._ids.indexOf(id);
        return this._index !== -1;
    }
    moveToTime (time) {
        if (!this._ids.length) return;
        while (0 < this._index && time <= this._startTimes[this._index - 1]) this._index--;
        while (this._index < this._ids.length && this._startTimes[this._index] < time) this._index++;
    }
	moveToFirstInView () {
		if (this._lastInView < this._firstInView) return false;
		return this.moveToPosition(this._firstInView);
	}
	moveToNextInView () {
		return this.moveToPosition(++this._index) && this._index <= this._lastInView;
	}
    hasPrev () {
        return 0 < this._index;
    }
    getPrev () {
        if (this.hasPrev()) return this._items[this._index - 1];
        else return false;
    }
    movePrev () {
        if (this.hasPrev()) return this._items[--this._index];
        else return false;
    }
    hasNext (){
        return this._index < this._ids.length - 1;
    }
    getNext () {
        if (this.hasNext()) return this._items[this._index + 1];
        else return false;
    }
    moveNext () {
        if (this.hasNext()) return this._items[++this._index];
        else return false;
    }
	updateInView (viewStartTime, viewEndTime) {
		if (this.isEmpty) return;

		let first = this._firstInView;
		let last = this._lastInView;

		while (0 < this._firstInView && viewStartTime < this._endTimes[this._firstInView - 1]) this._firstInView--;
		while (this._firstInView < this.count && this._endTimes[this._firstInView] < viewStartTime) this._firstInView++;
		while (0 <= this._lastInView && viewEndTime < this._startTimes[this._lastInView]) this._lastInView--;
		while (this._lastInView < this.count - 1 && this._startTimes[this._lastInView + 1] < viewEndTime) this._lastInView++;

		while (this._firstInView < first) this.checkView(--first, viewStartTime, viewEndTime);
		while (last < this._lastInView) this.checkView(++last, viewStartTime, viewEndTime);
		while (first < this._firstInView) this.checkView(first++, viewStartTime, viewEndTime);
		while (this._lastInView < last) this.checkView(last--, viewStartTime, viewEndTime);
	}
	checkView (index, start, end) {
		if (0 <= index && index < this.count) this._items[index].checkVisible(start, end);
	}
}